<!-- qr-scanner-modal.component.html - FIXED with iOS support -->
<ion-content>
  <!-- Close button -->
  <i class="fa fa-times close-button" (click)="close()" aria-label="Close scanner"></i>
  
  <!-- Main scanner container -->
  <div class="qr-scanner-container">
    <!-- Black overlay to hide video during dismiss -->
    <div 
      class="dismiss-overlay" 
      [class.active]="hasSuccessfullyScanned"
    ></div>
    
    <!-- Video element - always in DOM for proper cleanup -->
    <video
      #videoPreview
      class="qr-video"
      [class.visible]="cameraReady && !errorMessage && !hasSuccessfullyScanned"
      [class.success]="hasSuccessfullyScanned"
      autoplay
      muted
      playsinline
      webkit-playsinline
      x-webkit-airplay="deny"
    ></video>

    <!-- QR Frame with animated corners (only show when camera ready) -->
    <div 
      class="qr-frame" 
      [class.scanning]="scanning && cameraReady"
      [class.success]="hasSuccessfullyScanned"
      *ngIf="cameraReady && !errorMessage"
    >
      <div class="corner top-left"></div>
      <div class="corner top-right"></div>
      <div class="corner bottom-left"></div>
      <div class="corner bottom-right"></div>
    </div>

    <!-- Error State -->
    <div class="error-container" *ngIf="errorMessage">
      <ion-icon name="alert-circle" color="danger"></ion-icon>
      <h3>Camera Error</h3>
      <p>{{ errorMessage }}</p>
      <ion-button expand="block" (click)="retry()">
        <ion-icon name="refresh" slot="start"></ion-icon>
        Try Again
      </ion-button>
    </div>

    <!-- Loading State -->
    <div class="loading-container" *ngIf="!cameraReady && !errorMessage">
      <ion-spinner name="crescent"></ion-spinner>
      <p>Initializing camera...</p>
    </div>
  </div>
</ion-content>